import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import prefooterImg from '../resourses/PreFooter.svg'

const PreFooter = () => {
    const imgRef = React.useRef(null)
    const [isVisible, setIsVisible] = React.useState(false)

    React.useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting)
            },
            { threshold: 0.2 }
        )

        if (imgRef.current) {
            observer.observe(imgRef.current)
        }

        return () => observer.disconnect()
    }, [])

    return (
        <Container>
            <Row className="mt-4">
                <Col>
                    <img
                        ref={imgRef}
                        src={prefooterImg}
                        alt=""
                        className={isVisible ? "prefooter-fade-in visible" : "prefooter-fade-in"}
                        style={{width: "100%", objectFit: "cover"}}
                    />
                </Col>
            </Row>
        </Container>
    )
}

export default PreFooter